import {computed} from '@xh/hoist/mobx';
import {SpecModel, SpecModelConfig, SpecReducer} from '../spec/SpecModel';
import {applyOps, columnGroups, describeOps, findColumn, GridSpecOp, leafColumns, normalizeSpec} from './GridSpecOps';
import {GridSpec, GridSpecCapabilities, GridSpecColumn, GridSpecColumnGroup} from './GridSpecTypes';

export type GridSpecModelConfig = SpecModelConfig<GridSpec, GridSpecCapabilities>;

const gridSpecReducer: SpecReducer<GridSpec, GridSpecOp, GridSpecCapabilities> = {
    applyOps,
    normalizeSpec,
    describeOps,
    replaceOp: spec => ({op: 'replaceSpec', spec})
};

/**
 * Owns the GridSpec for one grid - see SpecModel for dispatch and undo. The configurator, the AI
 * assistant and the grid binder all change it through `dispatch()`.
 */
export class GridSpecModel extends SpecModel<GridSpec, GridSpecOp, GridSpecCapabilities> {
    constructor(config: GridSpecModelConfig) {
        super(gridSpecReducer, config);
    }

    @computed get leafColumns(): GridSpecColumn[] {
        return leafColumns(this.spec);
    }

    @computed get columnGroups(): GridSpecColumnGroup[] {
        return columnGroups(this.spec);
    }

    getColumn(field: string): GridSpecColumn {
        return findColumn(this.spec, field);
    }

    override fieldLabel(name: string): string {
        return this.getColumn(name)?.headerName ?? super.fieldLabel(name);
    }

    /** The field's own label from the catalog, ignoring any header the user gave the column. */
    catalogLabel(name: string): string {
        return super.fieldLabel(name);
    }
}
